import { t } from "@/i18n-js/instance";
import { signOutPath } from "@/react/helpers/urlHelpers";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { Typography } from "@circle-react-uikit/Typography";
import { useCheckoutUrl } from "../../../hooks/useCheckoutUrl";

export const CheckoutFormAccountDetails = () => {
  const { currentUser, currentCommunityMember } = usePaywallCheckoutContext();
  const user = currentCommunityMember || currentUser;
  const checkoutUrl = useCheckoutUrl();

  if (!user) {
    return null;
  }

  const signOutHref = `${signOutPath()}?redirect_back_url=${checkoutUrl}`;

  return (
    <div
      className="border-primary bg-primary shadow-xs flex flex-row items-center gap-x-4 rounded-xl border p-4"
      data-testid="checkout-form-account-details"
    >
      <UserImage src={user.avatar_url} name={user.name} size="10" />
      <div className="flex w-full flex-col justify-between">
        <div className="flex flex-row items-center justify-between">
          <Typography.LabelSm
            weight="medium"
            data-testid="checkout-form-account-details-name"
          >
            {user.name}
          </Typography.LabelSm>

          <Typography.LabelXs weight="medium">
            <a className="!text-dark cursor-pointer" href={signOutHref}>
              {t("sign_out")}
            </a>
          </Typography.LabelXs>
        </div>

        <Typography.LabelXs
          weight="medium"
          color="text-default"
          data-testid="checkout-form-account-details-email"
        >
          {user.email}
        </Typography.LabelXs>
      </div>
    </div>
  );
};
